(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const drawer = document.getElementById('cc-drawer');
    if (!drawer) return;

    const openers = document.querySelectorAll('[data-open-drawer]');
    const overlay = drawer.querySelector('.cc-drawer__overlay');
    const closers = drawer.querySelectorAll('[data-close-drawer]');

    const openDrawer = () => {
      drawer.classList.add('active');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cc-drawer-open');
    };

    const closeDrawer = () => {
      drawer.classList.remove('active');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cc-drawer-open');
    };

    openers.forEach(o => o.addEventListener('click', openDrawer));
    closers.forEach(c => c.addEventListener('click', closeDrawer));
    if (overlay) overlay.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') closeDrawer();
    });
  });
  } catch(e) { console.error(e); }
})();

})();
